
/**
 * @param {array} arr array of field names
 * @param {object} obj context of reactive data
 */
export const requiredFields = (arr, obj) => !arr.filter(item => obj[item] === '').length
